import { useState, useEffect } from 'react';
import { Mail, Info } from 'lucide-react';
import { useConfigTab, FORM_STYLES, Toggle, TagListInput, SaveButton, ConfigTimestamps, LoadingState } from './shared';

export function OrderSummaryTab({ merchantId, reloadKey }) {
  const { loading, saving, isNew, configValue, metadata, saveConfig } = useConfigTab(
    merchantId, 'MERCHANT_ORDER_SUMMARY_REPORT_CONFIGURATIONS', reloadKey,
  );

  const [enabled, setEnabled] = useState(false);
  const [recipientsTo, setRecipientsTo] = useState([]);
  const [recipientsCc, setRecipientsCc] = useState([]);
  const [recipientsBcc, setRecipientsBcc] = useState([]);

  useEffect(() => {
    if (!configValue) {
      setEnabled(false); setRecipientsTo([]); setRecipientsCc([]); setRecipientsBcc([]);
      return;
    }
    setEnabled(!!configValue.merchant_order_summary_report_generation_enabled);
    setRecipientsTo(Array.isArray(configValue.recipients_to) ? configValue.recipients_to : []);
    setRecipientsCc(Array.isArray(configValue.recipients_cc) ? configValue.recipients_cc : []);
    setRecipientsBcc(Array.isArray(configValue.recipients_bcc) ? configValue.recipients_bcc : []);
  }, [configValue]);

  const handleSave = () => {
    saveConfig({
      merchant_order_summary_report_configurations_value: {
        merchant_order_summary_report_generation_enabled: enabled,
        recipients_to: recipientsTo,
        recipients_cc: recipientsCc,
        recipients_bcc: recipientsBcc,
      },
    });
  };

  if (loading) return <LoadingState />;

  return (
    <div className="space-y-5">
      {isNew && (
        <div className="mb-4 flex items-center gap-2 px-4 py-3 bg-blue-50 border border-blue-100 rounded-lg text-sm text-blue-700">
          <Info className="w-4 h-4 shrink-0" />
          No existing configuration - fill the form below and save to create one.
        </div>
      )}

      <div className={FORM_STYLES.sectionCard}>
        <h3 className={FORM_STYLES.sectionTitle}>Report Settings</h3>
        <Toggle id="order-summary-enabled" label="Enable Order Summary Report Generation" checked={enabled} onChange={setEnabled} />
      </div>

      <div className={FORM_STYLES.sectionCard}>
        <h3 className={FORM_STYLES.sectionTitle}><Mail className="w-4 h-4 text-slate-400" /> Email Recipients</h3>
        <div className="space-y-4">
          <div>
            <label className={FORM_STYLES.label}>To</label>
            <TagListInput values={recipientsTo} onChange={setRecipientsTo} placeholder="Add email and press Enter" />
            <p className="text-xs text-slate-400 mt-1">Press Enter or click away to add each email address</p>
          </div>
          <div>
            <label className={FORM_STYLES.label}>CC</label>
            <TagListInput values={recipientsCc} onChange={setRecipientsCc} placeholder="Add CC email and press Enter" />
          </div>
          <div>
            <label className={FORM_STYLES.label}>BCC</label>
            <TagListInput values={recipientsBcc} onChange={setRecipientsBcc} placeholder="Add BCC email and press Enter" />
          </div>
        </div>
      </div>

      <SaveButton saving={saving} onClick={handleSave} />
      {!isNew && <ConfigTimestamps metadata={metadata} />}
    </div>
  );
}
